module.exports = __webpack_public_path__ + "assets/img/632800.b0c0b996.png";